// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface RoadIconSignature {
  Element: SVGSVGElement;
}

export const RoadIcon: TOC<RoadIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.976 2.783C17.875 2.327 17.469 2 17 2H7.00002C6.53102 2 6.12502 2.327 6.02402 2.783L2.02402 20.783C1.95802 21.079 2.03002 21.389 2.22002 21.626C2.41002 21.862 2.69702 22 3.00002 22H21C21.303 22 21.59 21.862 21.78 21.626C21.969 21.389 22.042 21.079 21.976 20.783L17.976 2.783ZM13 20V16H11V20H4.24702L7.80202 4H11V8H13V4H16.198L19.754 20H13ZM13 10H11V14H13V10Z"/>
</svg>
</template>;